import {
	LOGOUT, RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD,
	 RECEIVE_POST_USER_SET_PASSWORD,
	 REQUEST_POST_USER_SET_PASSWORD
} from "../actions/index";
import {SET_USER_SET_PASSWORD_SETTINGS} from "../actions";

const defaultState = {
	password: '',
	retypedPassword: '',
	hashCode: '',
	pathSearch: '',
	userId: '',
	code: '',
	badMsg:'',
	posting:false,
	msg: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_POST_USER_SET_PASSWORD:
			return {
				...state,
				posting: true
			};
		case RECEIVE_POST_USER_SET_PASSWORD:
			return {
				...state,
				posting: false,
				msg: 'Password created. Your account will not be accessible until ARAG activates it.'
			};
		case RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD:
			let errMsg = '';
			try {
				errMsg = action.payload.response.text;
			}
			catch (e) {
				errMsg = 'Failed to set/reset password.';
			}
			return {
				...state,
				posting: false,
				badMsg: errMsg
			};
		case SET_USER_SET_PASSWORD_SETTINGS:
			if(action.payload.key === 'badMsg' || action.payload.key === 'msg')
				return {
					...state,
					[action.payload.key]: action.payload.value
				};
			return {
				...state,
				[action.payload.key]: action.payload.value,
				badMsg: ''
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState,
				pathSearch:action.payload.location.search
			};
		case 'persist/REHYDRATE':
			return {
				...defaultState,
				pathSearch: state.pathSearch,
				hashCode: state.hashCode,
				userId: state.userId,
				code: state.code
			};
		default :
			return state
	}
}